import React, { Component } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  IconButton,
  ListItemSecondaryAction,
  Typography,
  ListSubheader,
  Button,
  Grid,
  InputAdornment
} from "@material-ui/core";
import RootRef from "@material-ui/core/RootRef";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import InboxIcon from "@material-ui/icons/Inbox";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import { apiURL } from "../util/config";

import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

const styles = theme => ({
  root: {
    padding: theme.spacing.unit
  },

  rightIcon: {
    marginLeft: theme.spacing.unit
  }
});

const getListStyle = isDraggingOver => ({
  //background: isDraggingOver ? 'lightblue' : 'lightgrey',
});

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: "rgb(235,235,235)"
  })
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  for (let i = 0; i < result.length; i++) {
    result[i].priority = i;
  }

  return result;
};

class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      projects: null,
      project: {},
      open: false,
      deleteOpen: false
    };

    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const projects = reorder(
      this.state.projects,
      result.source.index,
      result.destination.index
    );

    this.setState({
      projects
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.projects && props.projects) {
      return { ...state, projects: props.projects };
    } else {
      return null;
    }
  }

  saveProjects = () => {
    Axios.post(apiURL + "/Project/UpdateProjects", {
      secret: "test",
      projects: this.state.projects
    })
      .then(res => {})
      .catch(error => {
        console.log("error: ", error.response);
      });
  };

  handleClickOpen = project => () => {
    if (!project) {
      project = {
        title: "",
        description: "",
        markDown: "",
        images: [{ link: "" }],
        sourceLink: "",
        demoLink: "",
        status: ""
      };
    }

    this.setState({ open: true, project: project });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  saveProject = async() => {


    await Axios.post(apiURL + "/Project/UpdateProject", 
        this.state.project
    );

    await Axios.get(apiURL+"/Project/GetAll", {})
    .then((res) => {
        this.setState({projects: res.data});
    })
    .catch(function (error) { 
        console.log('error getting projects: ', error);
    });

    this.handleClose();
  };

  handleDelete = (project) => async() => {

    //delete project

    await Axios.get(apiURL + "/Project/DeleteProject", {params: {projectId: project.projectId}});

    await Axios.get(apiURL+"/Project/GetAll", {})
    .then((res) => {
        this.setState({projects: res.data});
    })
    .catch(function (error) { 
        console.log('error getting projects: ', error);
    });
  }

  handleProjectChange = (e) => {
      this.setState({project: {...this.state.project, [e.target.id]: e.target.value}});
  }
  
  handleProjectImageChange = (e) => {

    let images = this.state.project.images;
    let index = e.target.id.split(' ')[1];


    images[index].link = e.target.value;

    this.setState({project: {...this.state.project, images: images}});
}

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Typography variant="h2" align="center" gutterBottom>
          Projects
        </Typography>
        {this.state.projects && (
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <RootRef rootRef={provided.innerRef}>
                  <List style={getListStyle(snapshot.isDraggingOver)}>
                    {this.state.projects.map((p, index) => (
                      <Draggable
                        key={p.projectId}
                        draggableId={p.projectId}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <ListItem
                            ContainerComponent="li"
                            ContainerProps={{ ref: provided.innerRef }}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                          >
                            <ListItemIcon>
                              <InboxIcon />
                            </ListItemIcon>
                            <ListItemText
                              primary={p.priority + " - " + p.title}
                              secondary={p.description}
                            />
                            <ListItemSecondaryAction>
                              <IconButton onClick={this.handleClickOpen(p)}>
                                <EditIcon />
                              </IconButton>
                              <IconButton onClick={this.handleDelete(p)}>
                                <DeleteIcon />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </List>
                </RootRef>
              )}
            </Droppable>
          </DragDropContext>
        )}
        <Grid container spacing={8}>
          <Grid item>
            <Button
              variant="contained"
              size="large"
              color="secondary"
              onClick={this.saveProjects}
            >
              Save
              <SaveIcon className={classes.rightIcon} />
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              size="large"
              color="secondary"
              onClick={this.handleClickOpen()}
            >
              Create
              <CreateIcon className={classes.rightIcon} />
            </Button>
          </Grid>
        </Grid>

        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Project</DialogTitle>
          <DialogContent>

            <TextField
              autoFocus
              margin="dense"
              id="title"
              label="Title"
              fullWidth
              value={this.state.project.title}
              onChange={this.handleProjectChange}
            />
            <TextField
              margin="dense"
              id="description"
              label="Description"
              fullWidth
              value={this.state.project.description}
              onChange={this.handleProjectChange}
            />
            <TextField
              margin="dense"
              id="markDown"
              label="Mark down"
              fullWidth
              multiline
              rows="5"
              value={this.state.project.markDown}
              onChange={this.handleProjectChange}
            />
            <TextField
              margin="dense"
              id="sourceLink"
              label="Source Link"
              fullWidth
              value={this.state.project.sourceLink || ""}
              onChange={this.handleProjectChange}
            />
            <TextField
              margin="dense"
              id="demoLink"
              label="Demo Link"
              fullWidth
              value={this.state.project.demoLink || ""}
              onChange={this.handleProjectChange}
            />
            <TextField
              margin="dense"
              id="status"
              label="Status"
              fullWidth
              value={this.state.project.status}
              onChange={this.handleProjectChange}
            />
            {this.state.project.images &&
              this.state.project.images.map((image, index) => (
                <TextField
                  margin="dense"
                  id={"image " + index}
                  label={"Image Link " + index}
                  fullWidth
                  value={image.link}
                  key={index}
                  InputProps={
                    (index > 0 && {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              let project = this.state.project;

                              project.images.splice(index, 1);

                              this.setState({ project: project });
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </InputAdornment>
                      )
                    }) || null
                  }
                  onChange={this.handleProjectImageChange}
                />
              ))}
            <Button
              onClick={() => {
                this.setState({
                  project: {
                    ...this.state.project,
                    images: [...this.state.project.images, { link: "" }]
                  }
                });
              }}
              variant="contained"
              color="primary"
            >
              Add Image
            </Button>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.saveProject}
              variant="contained"
              color="secondary"
            >
              Save
            </Button>
            <Button
              onClick={this.handleClose}
              variant="contained"
              color="secondary"
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    );
  }
}

export default withStyles(styles)(Admin);
